/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewPublication } from '../../models/new-publication';
import { Publication } from '../../models/publication';

export interface EditorCreatePublication$Params {
      body?: NewPublication
}

export function editorCreatePublication(http: HttpClient, rootUrl: string, params?: EditorCreatePublication$Params, context?: HttpContext): Observable<StrictHttpResponse<Publication>> {
  const rb = new RequestBuilder(rootUrl, editorCreatePublication.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Publication>;
    })
  );
}

editorCreatePublication.PATH = '/editor/publications';
